module.exports = __webpack_public_path__ + "static/media/sims_logo_loading.513d8af2.png";